/**
 * The seeded EnumValue of the lookups this screen branches on. The API returns each option's
 * EnumValue alongside its name so the screen never has to match on a display name; these mirror the
 * KONE-24107 seed and the values are fixed by it.
 */
export enum ConstraintTypeValue {
  SubjectArea = 0,
  Format = 1,
  Source = 2,
  AudienceDesignator = 3,
}

export enum RecurrenceTypeValue {
  EveryCycle = 0,
  OneTime = 1,
  FirstRenewalOnly = 2,
  EveryNCycles = 3,
  TimeLimited = 4,
}

export enum DateSchemeTypeValue {
  FixedDate = 0,
  BirthDate = 1,
  LastDayBirthMonth = 2,
  LicenseIssueDate = 3,
  LastDayLicenseMonth = 4,
  OddEvenByLicenseNumber = 5,
  LastNameAlpha = 6,
  BoardAssigned = 7,
}

export enum OperatorTypeValue {
  Equals = 0,
  NotEquals = 1,
  GreaterThan = 2,
  LessThan = 3,
  GreaterThanOrEqual = 4,
  LessThanOrEqual = 5,
  InRange = 6,
}

/** The EnumValue of the option currently selected, or undefined when nothing is selected. */
export const selectedEnumValue = (
  options: { id?: string; enumValue?: number }[] | undefined,
  selectedId?: string
) => options?.find((option) => option.id === selectedId)?.enumValue;

/** Mirrors NoteTypes.EnumValue. An internal note is admin-only context and never reaches a learner. */
export enum NoteTypeValue {
  RegulatoryUrl = 0,
  BoardInstruction = 1,
  UserGuidance = 2,
  InternalNote = 3,
}

/** The localized label of a note type; undefined for a type this screen does not know, so the caller
 * falls back to the server name rather than showing a wrong one. */
export const noteTypeLabelKey = (enumValue?: number) => {
  switch (enumValue) {
    case NoteTypeValue.RegulatoryUrl:
      return "regulatoryUrl";
    case NoteTypeValue.BoardInstruction:
      return "boardInstruction";
    case NoteTypeValue.UserGuidance:
      return "userGuidance";
    case NoteTypeValue.InternalNote:
      return "internalNote";
    default:
      return undefined;
  }
};
